import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '.';
import { FeatureFlags } from '../utils/types';
import { assetServiceFeatureFlagsClient } from '../api-client/asset-service-client';
import { Loading } from '../utils/store';
import { resolveAxiosErrorResponse } from '../utils/errors';

type FeatureFlagsState = {
  flags: FeatureFlags;
  loading: Loading;
};

export const initialFeatureFlagsState: FeatureFlagsState = {
  flags: {
    FEATURE_FLAG_MAINTENANCE_MODE_ENABLED: false,
    FEATURE_FLAG_PRICE_MASTER_ENABLED: false,
  },
  loading: Loading.IDLE,
};

export const fetchFeatureFlags = createAsyncThunk('featureFlags/fetchFeatureFlagsStatus', async (_, { rejectWithValue }) => {
  try {
    const response = await assetServiceFeatureFlagsClient.featureFlags();
    return response.data.feature_flags;
  } catch (error) {
    return rejectWithValue(resolveAxiosErrorResponse(error)?.statusText);
  }
});

const featureFlags = createSlice({
  name: 'featureFlags',
  initialState: { ...initialFeatureFlagsState },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchFeatureFlags.pending, state => {
      state.loading = Loading.PENDING;
    });
    builder.addCase(fetchFeatureFlags.fulfilled, (state, action) => {
      if (action.payload) {
        state.flags = (action.payload as unknown as FeatureFlags) ?? { ...initialFeatureFlagsState.flags };
      }
      state.loading = Loading.SUCCEEDED;
    });
    builder.addCase(fetchFeatureFlags.rejected, state => {
      state.loading = Loading.FAILED;
    });
  },
});

export default featureFlags.reducer;

export const selectFeatureFlags = (state: RootState) => state.featureFlags.flags;
export const selectFeatureFlagsLoading = (state: RootState) => state.featureFlags.loading;
